import { useState } from 'react';
import { handleError } from '../../../components/errors/errorHandling';
import { addErrorToast } from '../../../components/errors/toast/ToastUtils';
import { deleteUser as deleteUserService, InvitationModel } from '../../../services/user/UserService';
import { useIntl } from 'react-intl';

interface Values {
  isLoading: boolean;
  deleteUser: (organizationId: string, organizationUser: InvitationModel) => Promise<boolean>;
}

const useDeleteUser = (): Values => {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const intl = useIntl();

  const deleteUser = async (organizationId: string, organizationUser: InvitationModel): Promise<boolean> => {
    try {
      setIsLoading(true);
      const result = await deleteUserService(organizationId, organizationUser);
      if (result.data === 1) {
        setIsLoading(false);
        return true;
      } else {
        setIsLoading(false);
        addErrorToast({ message: intl.formatMessage({ id: 'errors.generic' }) });
        return false;
      }
    } catch (error) {
      handleError(error);
      setIsLoading(false);
      return false;
    }
  };

  return { deleteUser, isLoading };
};

export default useDeleteUser;
